AppBase.module('Entities', function (Entities, App, Backbone) {
  'use strict'

  Entities.AssetReferenceAssociation = Backbone.RelationalModel.extend({
    defaults: {
      association_id: null,
      association_type: null,
      is_deletable: true,
    },
  })

  Entities.AssetReferenceAssociations = Backbone.Collection.extend({
    comparator: 'id',
    model: Entities.AssetReferenceAssociation,
  })
})
